var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoss"},[(!_vm.datas.src)?_c('section',{staticClass:"default"},[_c('van-icon',{attrs:{"name":"tv-o","size":"150px"}})],1):_c('section',{staticStyle:{"position":"relative"}},[_c('video',{attrs:{"src":_vm.datas.src,"controls":"","autoplay":_vm.datas.autoplay,"poster":_vm.datas.coverUrl,"width":"100%"}})]),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }